<div class="promotions-container">
  <h3 class="title">Promotions</h3>
  <div class="promo">
    <img src="../../../assets/images/world-club-ad.png" alt="">
  </div>
  <div class="promo">
    <img src="../../../assets/images/invite-ad.png" alt="">
  </div>
</div>
